/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Fragment } from "react";
import Slider from "react-slick";

import {
  activeThumbnailStyle,
  buttonStyle,
  goodsSliderDesign,
  notActiveThumbnailStyle,
  thumbnailBaseStyle,
  thumbnailImageStyle,
  thumbnailListStyle,
} from "./eventGoodsItemSliderV2Styles";
import { useEventGoodsItemSliderV2 } from "./useEventGoodsItemSliderV2";

import type { EventGoodsItemSliderV2props } from "./eventGoodsItemSliderV2props";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const EventGoodsItemSliderV2: FcWithoutChildren<
  EventGoodsItemSliderV2props
> = (props) => {
  const {
    activeIndex,
    capsuleThumbnail,
    isCapsuleGoodsSellingEnabled,
    setSliderRef,
    settings,
    slickGoto,
    thumbnailList,
  } = useEventGoodsItemSliderV2(props);
  const classesGoodsSliderDesign = goodsSliderDesign();

  const contents = isCapsuleGoodsSellingEnabled ? (
    <div className="mainImage">
      <img src={capsuleThumbnail} alt={""} />
    </div>
  ) : (
    <Fragment>
      <div>
        <Slider ref={setSliderRef} {...settings}>
          {thumbnailList.map((thumbnail, index) => {
            return (
              <div key={index} className="mainImage">
                <img src={thumbnail} alt="" />
              </div>
            );
          })}
        </Slider>
      </div>

      {thumbnailList.length > 1 && (
        <ul css={thumbnailListStyle}>
          {thumbnailList.map((thumbnail, index) => {
            const isActive = index === activeIndex;
            const thumbnailStyles = [
              thumbnailBaseStyle,
              isActive ? activeThumbnailStyle : notActiveThumbnailStyle,
            ];
            const handleClickThumbnail = () => {
              slickGoto(index);
            };
            return (
              <li key={index} css={thumbnailStyles}>
                <button css={buttonStyle} onClick={handleClickThumbnail}>
                  <img alt="" css={thumbnailImageStyle} src={thumbnail} />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </Fragment>
  );

  return <div css={classesGoodsSliderDesign.root}>{contents}</div>;
};
